
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import SidebarItem from './SidebarItem.vue'
import variables from '@/styles/_variables.scss'
import Cookies from 'js-cookie'

/** 与派送记录退款开关同思路：默认关，控制台 localStorage 可开 */
const ADMIN_SHOW_OPERATION_LOG_DEFAULT = false

function readShowOperationLog(): boolean {
  try {
    const v = localStorage.getItem('adminShowOperationLog')
    if (v === '1' || v === 'true') return true
    if (v === '0' || v === 'false') return false
  } catch (e) {}
  return ADMIN_SHOW_OPERATION_LOG_DEFAULT
}

@Component({
  name: 'SideBar',
  components: {
    SidebarItem
  }
})
export default class extends Vue {
  get name() {
    return (UserModule.userInfo as any).name
      ? (UserModule.userInfo as any).name
      : JSON.parse(Cookies.get('user_info') as any).name
  }

  get defOpen() {
    let path = ['/']
    this.routes.forEach((n: any) => {
      if (n.meta && n.meta.roles && n.meta.roles[0] === this.roles[0]) {
        path.splice(0, 1, n.path)
      }
    })
    return path
  }

  get defAct() {
    return this.$route.path
  }

  get sidebar() {
    return AppModule.sidebar
  }

  get storeId() {
    return UserModule.storeId || ''
  }

  get roles() {
    return UserModule.roles
  }

  get routes() {
    // 依赖 storeId，进入商户后强制重新计算菜单
    const _sid = this.storeId
    const routes = JSON.parse(
      JSON.stringify([...(this.$router as any).options.routes])
    )
    let menuList: any[] = []
    const menu = routes.find((item: any) => item.path === '/')
    if (menu) {
      menuList = menu.children || []
    }
    // 「操作日志」默认隐藏，控制台可开：
    // localStorage.setItem('adminShowOperationLog', '1')  // 显示
    // localStorage.setItem('adminShowOperationLog', '0')  // 隐藏
    // 然后刷新页面
    const showOperationLog = readShowOperationLog()
    menuList.forEach((route: any) => {
      if (route.path === 'operationLog') {
        if (!route.meta) route.meta = {}
        route.meta.hidden = !showOperationLog
      }
    })
    const hasStore = !!_sid
    if (!hasStore) {
      return menuList.filter((route: any) => !route.meta || !route.meta.requiresStore)
    }
    return menuList.filter((route: any) => !route.meta || !route.meta.hidden)
  }

  get variables() {
    return variables
  }

  get isCollapse() {
    return !this.sidebar.opened
  }

  private async logout() {
    this.$store.dispatch('LogOut').then(() => {
      this.$router.replace({ path: '/login' })
    })
  }
}
